import { render } from "./SignUpResult.vue?vue&type=template&id=221acf45&scoped=true"
import script from "./SignUpResult.vue?vue&type=script&lang=js"
export * from "./SignUpResult.vue?vue&type=script&lang=js"

import "./SignUpResult.vue?vue&type=style&index=0&id=221acf45&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3957297443/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221acf45"]])

export default __exports__